module.exports = __webpack_public_path__ + "static/media/546105af.jpg";